module.exports = __webpack_public_path__ + "assets/img/ok.0b3a33bc.svg";